import { computed } from "vue"
import { useAuthStore } from "@/stores/auth"

/**
 * Get the current auth state
 */
export function useAuthState() {
  const authStore = useAuthStore()
  return {
    isAuthenticated: computed(() => !!authStore.token),
    user: computed(() => authStore.user),
    tenant: computed(() => authStore.currentTenant),
    accessToken: computed(() => authStore.token),
    refreshToken: computed(() => authStore.refresh_token),
  }
}

/**
 * Get headers for authenticated requests
 */
export function getAuthHeaders() {
  const { accessToken, tenant } = useAuthState()
  const headers: Record<string, string> = {}

  if (accessToken.value) {
    headers.Authorization = `Bearer ${accessToken.value}`
  }

  if (tenant.value?.id != null) {
    headers["X-Tenant"] = String(tenant.value.id)
  }

  return headers
}
